import { createTheme } from '@mui/material/styles';
import { responsiveFontSizes } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

let theme = createTheme({
  palette: {
    primary: {
      main: '#432f13',      // Your brown color
      light: '#6a4b1f',     // Lighter version
      dark: '#35230b',      // Darker version
    },
    secondary: {
      main: '#f2cab6',      // Your sunset peach color
      light: '#ffdcc9',
      dark: '#d4ac98',
    },
  },  breakpoints: {
    values: {
      xs: 0,  
      sm: 700,     // Small devices
      md: 1100,   // Medium devices
      lg: 1300,  // Large devices
      xl: 1920,  // Extra-large devices
    }
  },

  components: {
    MuiTypography: {
      variants: [
        {
          props: { variant: 'rsvphead' },
          styleOverrides: {
            root: {
              fontFamily: 'serif',
              fontWeight: 400,
              fontStyle: 'normal',
              color: '#36523c',
              fontSize: '1.8rem',
            }
          }
        },
        {
          props: { variant: 'rsvpsub' },
          styleOverrides: {
            root: {
              fontFamily: 'serif',
              fontWeight: 400,
              fontStyle: 'normal',
              color: '#36523c',
              fontSize: '1.2rem',
            }
          }
        }
      ]
    }
  },
  typography: {
    h1: {
      fontFamily: '"Slight", serif',
      fontWeight: 400,
      fontStyle: 'normal',
      color: '#36523c',
      fontSize: '6rem',
      lineHeight: '1.2',
      margin: 0,
      // textShadow: '3px 3px 2px oklch(17.59% 0.0489 148.99 / 0.5)',
    },
    h2: {
      fontFamily: 'serif',
      fontWeight: 500,
      fontStyle: 'normal',
      color: '#36523c',
      fontSize: '1.6rem',
    },
    h3: {
      fontFamily: '"Slight", serif',
      fontWeight: 600,
      fontStyle: 'normal',
      color: '#36523c',
      fontSize: '3rem',
    },
    h4: {
      fontFamily: 'Quicksand',
      fontWeight: 500,
      fontStyle: 'normal',
      color: '#36523c',
      fontSize: '1.5rem',
    },
    h6: {
      fontFamily: 'Quicksand',
      fontWeight: 400,
      fontStyle: 'normal',
      color: '#36523c',
      fontSize: '1.1rem',
    },
  },
});

theme = responsiveFontSizes(theme, {
  breakpoints: ['xs', 'sm', 'md', 'lg', 'xl'],
  factor: 2, 
});


export const RsvpText = styled(Typography)({
  fontFamily: 'serif',
  fontWeight: 400,
  fontStyle: 'normal',
  color: '#36523c',
});

export const RsvpInput = styled(Typography)({
  fontFamily: 'Quicksand',
  fontWeight: 500,
  fontStyle: 'normal',
  color: '#36523c',
});


export default theme;
